import { useNavigate } from "react-router-dom";
import { DefaultButton } from "../button/defaultButton/DefaultButton";
import styles from "./ErrorPage.module.scss";
import {
  getDefaultRoutePath,
} from "../../infrastructure/routes/routePaths";
import { useAppContext } from "../../../AppContext";

export const ErrorPage = () => {
  const navigate = useNavigate();
  const { currentUser } = useAppContext();

  const backToPlanner = () => {
    navigate(getDefaultRoutePath(currentUser));
  };

  return (
    <div className={styles.root}>
      <p>За страницата не беше намерена.</p>
      <DefaultButton
        className={styles.root_button}
        label={"Обратно към Календара"}
        onClick={backToPlanner}
      />
    </div>
  );
};
